import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useRejectPartner() {
  const { t } = useTranslation(['partners', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { deleter } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const rejectPartner = async (partnerId: number) => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      await deleter<void>(
        `${CONFIG.BOUNCE_API}/api/v1/partners/${partnerId}/reject`
      )
      setSuccess(t('partners:partners.hook.successfully-rejected'))
      return true
    } catch (caughtError) {
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return false
    } finally {
      setLoading(false)
    }
  }

  return { rejectPartner, loading, error, success, resetState }
}
